import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-solar-list',
  templateUrl: './solar-list.component.html',
  styleUrls: ['./solar-list.component.scss']
})
export class SolarListComponent implements OnInit {
  @ViewChild('queryDataTable', { static: true })
  public queryDataTable: Table;
  
  public userId: any;
  public solarListPassword: any;
  public downloadPassword: any;
  public fileBackupValue: boolean;


  public isSubmittedForSolarList: boolean = false;

  public tableData: any = [];
  public tableColumns: any = [];


  constructor(
    private cryptoJsService: CryptoJsService, 
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private loader: AppLoaderService,
    private apiService: DashboardService,
  ) { }


  ngOnInit(): void {
    const token: any = JSON.parse(sessionStorage.getItem('token'));
    // console.log('token1', token);
    // this.vendorRegId = JSON.stringify(token?.officeCode);
    // console.log('officeCode', this.vendorRegId);
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    
  }

  onSubmitSolarList(){
    if(this.solarListPassword == null || this.solarListPassword == ''){
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: "Please Enter a Password",
      });
      return
    }
    this.isSubmittedForSolarList = true;
    let reqBody = {
      userId: this.cryptoJsService.Encrypt(this.userId),
      passCode: this.cryptoJsService.Encrypt(this.solarListPassword)
    }
    this.getSolarList(reqBody);
    // this.tableColumns = Object.keys({"FileName":"Micada_New_0702-280220234.bak","userId":null,"PassCode":null})
    // this.tableData = [{"FileName":"Micada_New_0702-060320234.bak","userId":null,"PassCode":null},{"FileName":"Micada_New_0702-280220234.bak","userId":null,"PassCode":null}]
  }

  getSolarList(reqBody){
    this.loader.start();
    this.apiService
      .solarList(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          // this.query = null;

          if(Array.isArray(data) ?  data.length == 0 : false){
            this.tableColumns = [];
            this.tableData = [];
          }
          else{
            this.tableColumns = Object.keys(data[0])
            this.tableData = data;
          }

        },
        error: (err) => {
          this.loader.close();
          this.tableColumns = [];
          this.tableData = [];
          this.isSubmittedForSolarList = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        }
      });
  }

  onTooglebutton(val){
    this.fileBackupValue = val.checked
  }

  onSubmitFileBackup() {
    this.solarBackup(this.fileBackupValue);
  }


  solarBackup(fileBackupValue){
    this.loader.start();
    this.apiService
      .solarBackup(fileBackupValue)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: data,
          });
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        }
      });
  }


  onDelete(val){
    let reqBody = {
      userId: this.cryptoJsService.Encrypt(this.userId),
      passCode: this.cryptoJsService.Encrypt(this.solarListPassword),
      text: this.cryptoJsService.Encrypt(val?.FileName)
    }

    this.removedbbackup(reqBody);
  
  }

  removedbbackup(reqBody){
    this.loader.start();
    this.apiService
      .removedbbackup(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: JSON.stringify(data),
          });
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        complete: () => {
        }
      });
  }


  onDownload(val){
    let reqBody = {
      userId: this.cryptoJsService.Encrypt(this.userId),
      passCode: this.cryptoJsService.Encrypt(this.solarListPassword),
      fileName: this.cryptoJsService.Encrypt(val?.FileName)
    }

    this.downloadsolar(reqBody);
  }

  downloadsolar(reqBody){
    this.loader.start();
    this.apiService
      .downloadsolar(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: JSON.stringify(data),
          });
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        complete: () => {
        }
      });
  }
}

